import type { GraphQLClient } from "../../../core/utils/aws/appsync/GraphQLClient.js";
import type { CognitoClient } from "../../../core/utils/aws/cognito/CognitoClient.js";
import type { StorageClient } from "../../../core/utils/aws/s3/StorageClient.js";
import type { GlobalSettings } from "../GlobalSettings.js";

interface Clients {
	cognito: CognitoClient;
	graphQL: GraphQLClient;
	uploadStorage: StorageClient;
}

let clients: Clients | undefined;

export async function getClients(globalSettings: GlobalSettings): Promise<Clients> {
	if (clients) {
		return clients;
	}

	if (typeof window === "undefined") {
		return {} as Clients;
	}

	const {
		AWS_REGION,
		AWS_USER_POOL_ID,
		AWS_IDENTITY_POOL_ID,
		AWS_USER_POOL_CLIENT_ID,
		PUBLIC_GRAPHQL_ENDPOINT,
		UPLOAD_BUCKET,
	} = globalSettings;

	const { GraphQLClient } = await import("../../../core/utils/aws/appsync/GraphQLClient.js");
	const { CognitoClient } = await import("../../../core/utils/aws/cognito/CognitoClient.js");
	const { StorageClient } = await import("../../../core/utils/aws/s3/StorageClient.js");

	let graphQL: GraphQLClient | undefined;
	let uploadStorage: StorageClient | undefined;
	const cognito = new CognitoClient(
		AWS_REGION,
		AWS_USER_POOL_CLIENT_ID,
		AWS_IDENTITY_POOL_ID,
		AWS_USER_POOL_ID,
		true,
		(credentialProvider) => {
			graphQL = new GraphQLClient(AWS_REGION, PUBLIC_GRAPHQL_ENDPOINT, credentialProvider, import.meta.env.DEV);
			uploadStorage = new StorageClient(AWS_REGION, UPLOAD_BUCKET, credentialProvider);
			if (clients) {
				clients.graphQL = graphQL;
				clients.uploadStorage = uploadStorage;
			}
		},
	);
	if (!graphQL || !uploadStorage) {
		throw new Error("Clients not created");
	}

	// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition,@typescript-eslint/strict-boolean-expressions
	if (!clients) {
		clients = {
			cognito,
			graphQL,
			uploadStorage,
		};
	}

	return clients;
}
